import api from './AxiosInstance';

export class DemandeAgrService {
  getOneDemandeAgr = async (numFourn) => {
    try {
      const response = await api.get(`/Fournisseur/${numFourn}`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  getAllLDemandeAgr = async () => {
    try {
      const response = await api.get(`/Fournisseur/DemandeAgrement/list`, {
     
      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
      // Gérer l'erreur ici si nécessaire
      throw error; 
    }
  };
  
  ajoutDemandeAgr= async ( payload) => {
    try {
    
  
      const response = await api.post(`/Fournisseur/add`, payload )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };

  supDemandeAgr= async ( numFourn ) => {
    try {
    
      const response = await api.delete(`/Fournisseur/${numFourn}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
 //
  modifDemandeAgr= async ( payload) => {
    try {
     
  
      const response = await api.put(`/Fournisseur/updateAgrement`, payload)
  
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  addDemandeAgr= async ( newPrestation) => {
    try {
    
  
      const response = await api.post(`/Benef/typeBenef/add`, newPrestation )
      
      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de prestation :', error);
      // Gérer l'erreur ici si nécessaire
      throw error;
    }
  };


  updateDemandeAgr= async ( updatedPrestation) => {
    try {
     

      const response = await api.put(`/Benef/typeBenef/update`, updatedPrestation)

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de prestation :', error);
      throw error;
    }
  };

  deleteDemandeAgr= async ( prestationId) => {
    try {
    
      const response = await api.delete(`/Benef/typeBenef/delete/${prestationId}`) 

      return response.data;
    } catch (error) {
      console.error('Erreur lors de la suppression de prestation :', error);
      throw error;
    }
  };
}


